import React from 'react';
import { FiArrowRight, FiZap } from 'react-icons/fi';
import PageHero from '../../fx/PageHero';

const Hero = () => {
    return (
        <PageHero
            pill="TRAINING PROGRAMS"
            title={[
                { text: 'Elevate your' },
                { text: 'cybersecurity skills.', gradient: true },
            ]}
            desc="Immersive training programs, from beginner to advanced, designed by industry professionals to build defenders for the digital frontier."
            actions={[
                { label: 'Request training', primary: true, icon: <FiArrowRight />, to: '#contact', onClick: (e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); } },
                { label: 'Explore programs', icon: <FiZap />, to: '#services', onClick: (e) => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); } },
            ]}
        />
    );
};

export default Hero;
